!function (win){
    // 由分销用户进入的隐藏banner
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const param1 = params.get('from');
    if (param1 === 'distribution') {
        const elements = document.querySelectorAll('.banner-img');
        elements.forEach(element => {
            element.style.display = 'none';
        });
    }
    var apkUrl = '';
    var serverUrl = ['test-', 'localhost'].some((cur) => {
        return location.host.includes(cur)
    }) ? 'https://test-portal.qzdjpq.com/api/v1/card_android/versions' : 'https://portal.qzdjpq.com/api/v1/card_android/versions';

    
    document.addEventListener('DOMContentLoaded', function() {
        _request_link(function (res) {
            if (!res || !res.info) {
                console.error('versions 未配置！');
                return
            }

            var version = res.info.find(version => version.channel === "c_official");
            if (!version) {
                version = res.info.find(version => version.channel === "*");
            }

            if (!version) {
                console.error('versions 无默认值！');
            }

            apkUrl = version.url;
        })
    });


    function _request_link (callback) {
        var request = new XMLHttpRequest();
        request.open('get', serverUrl);
        request.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
        request.onload = function () {
            if (this.status != 200) {
                console.error('接口请求失败');
                apkUrl = 'https://d.qzdjpq.com/littlesix/app/apk/pro/c_official.apk' // 接口失败默认地址
            }

            callback && callback(JSON.parse(request.responseText));
        }
        request.onerror = function () {
            apkUrl = 'https://d.qzdjpq.com/littlesix/app/apk/pro/c_official.apk' // 接口失败默认地址
        }
        request.send();
    }

    sensors.track('app_poker_official_site_home')
    
    let slideIndex = 1;
    showSlides(slideIndex);

    function plusSlides(n) {
        showSlides(slideIndex += n);
    }

    function currentSlide(n) {
        showSlides(slideIndex = n);
    }

    function showSlides(n) {
        let i;
        const slides = document.getElementsByClassName("carousel-item");
        if (n > slides.length) { slideIndex = 1 }
        if (n < 1) { slideIndex = slides.length }
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        slides[slideIndex - 1].style.display = "block";
    }

    // 自动轮播
    let slideInterval = setInterval(() => {
        plusSlides(1);
    }, 3000); // 每隔3秒自动切换

    // 鼠标悬停时停止自动轮播
    const slideshowContainer = document.querySelector(".carousel");
    slideshowContainer.addEventListener("mouseenter", () => {
        clearInterval(slideInterval);
    });

    // 鼠标离开时恢复自动轮播
    slideshowContainer.addEventListener("mouseleave", () => {
        slideInterval = setInterval(() => {
            plusSlides(1);
        }, 3000);
    });

    function dowload (isIos) {
        // 微信内提示到浏览器下载
        if (isWeChatBrowser()) {
            openWXNotice()
            return
        }

        // var apkUrl = 'https://d.littlesix.mobi/littlesix/app/apk/pro/card-1.0-vc10002-c_gray-5df4d09_c_official_signed.apk'; //TODO
        if (isIos) {
            window.open('https://apps.apple.com/cn/app/%E5%85%A8%E8%87%AA%E5%8A%A8%E8%AE%B0%E7%89%8C%E5%99%A8/id6505105821')
            document.querySelector('.android-btn').style.backgroundColor = '#333333'
            document.querySelector('.ios-btn').style.backgroundColor = '#F69841'
            sensors.track('app_poker_official_site_download', {'click_platform': 'iOS'})
            return
        }

        
        window.open(_is_ios() ? 'https://apps.apple.com/cn/app/%E5%85%A8%E8%87%AA%E5%8A%A8%E8%AE%B0%E7%89%8C%E5%99%A8/id6505105821' : apkUrl);
        document.querySelector('.android-btn').style.backgroundColor = '#F69841'
        document.querySelector('.ios-btn').style.backgroundColor = '#333333'
        sensors.track('app_poker_official_site_download', {'click_platform': _is_ios() ? 'iOS' : 'Android'})
    }

    win.dowload = dowload
    win.plusSlides = plusSlides
}(window)